import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    revokedDeletion?: boolean;
}

export async function fetchAuthenticationTokens(refreshToken: string) {
    const formData = new FormData();

    formData.append('client_id', 'web');
    formData.append('scope', '__all__');
    formData.append('grant_type', 'refresh_token');
    formData.append('refresh_token', refreshToken);

    const { data } = await axios.post<IResponse>(Endpoints.Auth.Token, formData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

    return data;
}
